// LIBRARIES
import styled, { css } from "styled-components";
import CancelIcon from "@mui/icons-material/Cancel";

// MISC
import { COLORS, FONTS, WIDTH } from "constants/styleVariables";
import { Switch, Typography } from "@mui/material";

export const Container = styled.div`
height: 100%;
width: 1000px;
// width: 90%;
height: 100%;
justify-content: center;
border-bottom-left-radius: 24px;
border-top-left-radius: 24px;
background-color: #F5F5F5;
position: absolute;
right: 0%;
display: flex;
flex-direction: column;
outline: none;
padding: 80px;
@media screen and (max-width: 1000px) {
  width: 100%;
  padding: 40px;
}
  @media (${WIDTH.tabletWidth}) {
    overflow: hidden;
    overflow-y: scroll;
    align-items: center;
    ::-webkit-scrollbar {
      width: 3px;
    }
    ::-webkit-scrollbar-track {
      background-color: ${COLORS.backgroundColor};
      border-radius: 10px;
      margin-block: 9px;
      margin-left: 28px;
    }
    ::-webkit-scrollbar-thumb {
      background-image: linear-gradient(
        180deg,
        ${COLORS.rainbowIndigo} 0%,
        ${COLORS.rainbowIndigo} 100%
      );
  }
`;
export const SettingsContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-around;
  // width: 950px;
  // height: 500px;
  margin-bottom: 10px;
  @media (max-width: 563px) {
    justify-content: center;
   }
`;

export const StatusSettingsContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: space-between;
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  @media (max-width: 563px) {
    height: 100%;
   }
`;

export const SettingElement = styled.div`
  display: flex;
  flex-direction: column;
  // margin-bottom: 20px;
  // margin-right: 50px;
`;
export const CloseIconContainer = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
`;

export const CloseIcon = styled(CancelIcon)`
  && {
    color: ${COLORS.thirdGray};
    padding: 0;
    margin-bottom: 0;
    cursor: pointer;
  }
`;

export const Title = styled.text`
  text-align: center;
  font-size: 30px;
  font-family: ${FONTS.poppins};
  font-weight: bold;
  color: ${COLORS.terraCotta};
  margin-bottom: 40px;
`;

export const Subtitle = styled.text`
  font-size: 20px;
  font-family: ${FONTS.montserrat};
  font-weight: bold;
  color: ${COLORS.secondaryBlack};
  margin-bottom: 20px;
  @media (max-width: 563px) {
    text-align: center;
   }
  
`;

export const SettingTitle = styled.text`
  font-size: 16px;
  font-family: ${FONTS.montserrat};
  font-weight: 600;
  color: ${COLORS.secondaryBlack};
  margin-bottom: 10px;
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LabelContainer = styled(Typography)(
  ({ colorValue }) => css`
    font-family: ${FONTS.montserrat};
    color: ${colorValue};
  `
);

export const ButtonContainer = styled.div`
  margin: 0 auto;
`;

export const ToggleSwitch = styled(Switch)(
  ({ colorValue }) => css`
    .MuiSwitch-thumb {
      color: ${colorValue};
    }
  `
);
